/* eslint-disable */
import React, { useContext } from 'react';
import { CapabilitiesRow } from '@thd-olt-component-react/capabilities-tile';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { MarketingOffers } from './MarketingOffers';
import { HeroCarousel } from './HeroCarousel';
import { FallbackSection } from './FallbackSection';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from '../context/HomepageContext';
import { CUSTOMER_TYPES } from '../../utils';

export function SectionSelector(props) {
  if (!props.children || props.children.length === 0) return null;
  
  const {
    children,
    id: entryId,
    title,
    customRenderId,
    __typename,
  } = props;

  const { customerType, proCustomerSegment, hydrationOptions } = useContext(HomepageContext);
  const isB2B = customerType === CUSTOMER_TYPES.B2B;
  const proAnalyticsData = {};
  
  if (isB2B) {
    proAnalyticsData.isB2B = true;
    proAnalyticsData.templates = proCustomerSegment;
  }

  switch (customRenderId) {
    case 'Capabilities Tile': {
      return (
        <ErrorBoundary name="section-capabilities-tile">
            <ImpressionProvider
              data={{
                id: entryId,
                name: 'Section',
                component: 'Section',
                type: 'content',
                position: '',
              }}
            >
              <CapabilitiesRow 
                  children={children}
                  id={entryId}
                  title={title}
                  customRenderId={customRenderId}
                  __typename={__typename}
                  hydrationOptions={hydrationOptions}
                  proAnalyticsData={proAnalyticsData}
              />
            </ImpressionProvider>
        </ErrorBoundary>
      );
    }
    case 'Marketing Gallery':
    case 'B2B Marketing Gallery': {
      return (
        <ErrorBoundary name="section-marketing-offers">
          <MarketingOffers {...props} />
        </ErrorBoundary>
      );
    }

    case 'Hero Carousel': {
      return (
        <ErrorBoundary name="section-hero-carousel">
            <HeroCarousel {...props} />
        </ErrorBoundary>
      );
    }

    default: {
      return (
        <ErrorBoundary name="section-fallback">
          <FallbackSection {...props} />
        </ErrorBoundary>
      );
    }
  }
}
